document.addEventListener("turbolinks:load", () => {
    document.querySelectorAll(".add_fields").forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const time = new Date().getTime();
            const linkId = link.dataset.id;
            const regexp = new RegExp(linkId, "g");
            const newFields = link.dataset.fields.replace(regexp, time);
            link.insertAdjacentHTML("beforebegin", newFields);
        });
    });

    document.addEventListener("click", function (e) {
        if (e.target && e.target.classList.contains("remove_fields")) {
            e.preventDefault();
            e.target.closest(".nested-fields").remove();
        }
    });
});
